goog.provide('el8.shared.commentReplyForm');

goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.template.passport.render.letter');
goog.require('el8.template.ptdata.letters');
goog.require('el8.template.shared.commentReplyForm');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.util.string');
goog.require('el8.util.validate');


/**
 * This form is used to add a comment to a letter, from
 * apphome, appchart, and passport.
 *
 * It is structured a little oddly because we need to support
 * multiple copies of this form existing on the same page, so every call
 * to el8.shared.commentReplyForm.show() needs to keep independent vars
 */
el8.shared.commentReplyForm = (function() {

    var module = {};

    module.show = function(spec) {

        var container = spec.container;
        var docId = spec.docId;
        var sendCb = spec.sendCallback;
        var cancelCb = spec.cancelCallback;
        var inProgressText = spec.inProgressText || null;
        var noFirstFocus = spec.noFirstFocus || false;

        var form = null;

        var fromEmr = (el8Globals.APP === 'chart' || el8Globals.APP === 'home');

        var isLetter = true;
        if (el8.model.idToModelClass(docId) === 'LetterReceipt') { isLetter = false; }

        /**
         * Internal functions. They're defined inside show() so they
         * can easily use the variables passed in from spec.
         */
         var createForm, sendFn, hide;
         createForm = function() {
            // populates and renders the 'form' object declared above
            form = new el8.uiwidget.Form({
                container: $('.comment-reply-form', container),
                buttonElt: $('.comment-reply-buttons', container),
                fields: [
                    {
                        name: 'replyBody',
                        selector: ':input[name="replyBody"]',
                        infoText: el8.template.shared.commentReplyForm.replyText(),
                        height: el8.util.consts.DEFAULT_FIELD_HEIGHT * 4,
                        validate: {
                            required: true
                        },
                        defaultVal: inProgressText
                    }
                ],
                validationOpts: el8.util.validate.standardOpts,
                noFirstFocus: noFirstFocus
            });
            var document = getDocument(el8Globals.APP, docId);


            // reciept and pt-sent
            if (!isLetter && document.isPtLetter()) {

                // un-signed
                if (!document.isSignedOff()) {
                    form.addButton('send-sign',
                                   'Reply & Sign Off',
                                   function() { sendFn({sign: true}); },
                                   true);

                    form.addButton('send-sign-close',
                                   'Reply, Sign Off & End Conversation',
                                   function() { sendFn({sign: true, closeThread: true}); },
                                   false);
                // signed
                } else {
                    form.addButton('send',
                                   'Reply',
                                   function() { sendFn(); },
                                   true);

                    form.addButton('send-close',
                                   'Reply & End Conversation',
                                   function() { sendFn({closeThread: true}); },
                                   false);
                }

            // letter or not pt-sent
            } else {
                form.addButton('send', 'Reply', function() { sendFn(); }, true);

                if (fromEmr && isLetter && !document.getSendToAccessUserId()) {
                    // patients shouldn't close threads and access letters shouldn't be closed
                    form.addButton('send-close', 'Reply & End Conversation', function() { sendFn({closeThread: true}); });
                }
                if (!isLetter && !document.isSignedOff()) {
                    form.addButton('send-sign',
                                   'Reply & Sign Off',
                                   function() { sendFn({sign: true}); });
                }
            }

            form.addButton('cancel', 'Discard Reply', function() {
                var document = getDocument(el8Globals.APP, docId);
                // put a reply trigger back in the space the user originally clicked on
                $('.comment-reply-container', container).replaceWith(
                    el8.template.shared.commentReplyForm.replyTrigger(document.asSoyMap())
                );
                if (cancelCb) { cancelCb(); }

                document.setInProgressComment('');
                hide();
            });
            form.render();
         };

         sendFn = function(opts) {
            opts = opts || {};
            if (!form.isValid()) { return; }

            form.disable();
            var document = getDocument(el8Globals.APP, docId);
            var commentsTemplateFn = getCommentTemplateFn(el8Globals.APP, docId);

            var addCommentParams = {
                message: el8.util.string.cleanMultiByteChars(form.getVal('replyBody')),
                closeThread: opts.closeThread,
                successCb: function(updated) {
                    // re-render the whole list of comments, since new-status (readTimes) may have changed
                    $('.letter-comments', container).replaceWith(
                        commentsTemplateFn(updated.asSoyMap())
                    );
                    if (sendCb) { sendCb(updated); }
                    hide();
                }
            };
            if (el8Globals.APP !== 'access') { // no closed threads in access
                addCommentParams['errorOverrideCb'] = function(data) {
                    var alertFn = getAlertFn(el8Globals.APP);
                    if (data.status === 409) {
                        /* We're going to fetch an updated copy of the letter so it can be re-rendered appropriately
                           in passport, if the user goes to the timeline and then comes back. We won't re-render
                           immediately, though, so the user can copy their text out. */
                        var fetchArgs = {
                            fetchId: docId,
                            force: true,
                            async: true
                        };
                        var fetchFn = getFetchFn(el8Globals.APP);

                        alertFn(el8.template.shared.commentReplyForm.commentsClosedError());
                        fetchFn(fetchArgs);
                    } else {
                        if (el8Globals.APP === 'passport') {
                            el8.passport.notifier.notify(el8.util.consts.PASSPORT_DEFAULT_ERROR_MSG);
                        } else {
                            el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                        }
                        form.enable();
                    }
                };
            } else {
                addCommentParams['errorCb'] = function() { form.enable(); };
            }

            // for LetterReceipts sign first, then addComment()
            if (document.is('LetterReceipt') && opts.sign) {
                document.sign({
                    successCb: function(updated) {
                      updated.addComment(addCommentParams);
                      form.clearField('replyBody');
                    }
                });
            } else {
                document.addComment(addCommentParams);
                form.clearField('replyBody');
            }

            // clear any in-progress comment on this item
            document.setInProgressComment('');
         };

         hide = function() {
            /* help the GC */
            createForm = null;
            sendFn = null;
            container = null;
            docId = null;
            sendCb = null;
            cancelCb = null;
            form = null;
         };

         /**
          * The work of the function
          */
         // replace the reply trigger with an inline form
         $('.comment-reply-container', container).replaceWith(
             el8.template.shared.commentReplyForm.inlineDialog()
         );

         // open the responses section, if not already open (for the outstanding feed)
         if (inProgressText) {
            $('.letter-responses-section', container).show();
        }

         createForm();

    };

    function getDocument(app, docId) {
        if (app === 'access') { return el8.access.letterSummaries.getById(docId); }
        return (el8.model.idToModelClass(docId) === 'Letter') ?
            el8.ptdata.letters.getById(docId) : el8.ptdata.letterReceipts.getById(docId);
    }

    function getCommentTemplateFn(app, docId) {
        if (app === 'passport') { return el8.template.passport.render.letter.commentSection; }
        if (app === 'access') { return el8.template.access.render.letter.commentSection; }

        var mClass = el8.model.idToModelClass(docId);
        if (mClass === 'Letter') {
            return el8.template.ptdata.letters.commentSection;
        } else if (mClass === 'LetterReceipt') {
            return el8.template.ptdata.letterReceipts.commentSection;
        }

        return null;
    }

    function getAlertFn(app) {
        if (app === 'passport') { return el8.passport.notifier.notify; }
        if (app === 'access') { return el8.access.notifier.notify; }
        return el8.uiwidget.alert;
    }

    function getFetchFn(app) {
        /* NOTE: we're not goog.require-ing passport.fetch or ptdata.fetch - in the appropriate
           context, one of the two should have already been loaded and we don't want ptdata.fetch in passport
           or passport fetch in the EMR */
        if (app === 'passport') { return el8.passport.fetch; }
        return el8.ptdata.fetch;
    }


    return module;

})();
